









































import router from "../router";
import ripple from "./ripple.vue";
import userIcon from "./userIcon.vue";
import gbutton from "./button.vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {frontendClient} from "../lib/client";

export interface WarningInterface{
    text:string,
    options:{
        text:string,
        function: any
    }[]
}

@Component({
    components: {
        ripple,
        userIcon,
        gbutton
    }
})
export default class WarningPopup extends Vue {

    @Prop({}) content:boolean;

    warning:WarningInterface = null;
    shouldResolve:Function = null;
    shouldReject:any = null;

    create(mountable: Vue, warning:WarningInterface){
        let promise = this.createPromise();

        warning.options.forEach(element => {
            if(element.function == "resolve"){
                element.function = this.shouldResolve;
            }else if(element.function == "reject"){
                element.function = this.shouldReject;
            }
        });
        this.warning = warning;

        this.$mount();

        document.body.appendChild(this.$el);
        return promise;
    }

    createPromise():Promise<any>{
        return new Promise<any>((resolve, reject) => {
            this.shouldResolve = () => {
                this.kill();
                resolve();
            };
            this.shouldReject = () => {
                this.kill();
                reject();
            };
        })
    }

    kill(){
        this.$el.remove();
    }

    close(){
        if(this.content){
            this.$emit('closed');
        }else{
            this.shouldReject();
        }
    }
}

